import React from "react";
import CTA from "./CTA";
import "./Header.css";
import Headerpic from "../../assests/Headerpic.png";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Sharmil Macwan</h1>
        <h5 className="text-light">
          Fullstack Developer | Software Engineer | ML Engineer
        </h5>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={Headerpic} alt="me" />
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
